var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorWrapper"},[_c('div',{staticClass:"errorPin"}),_vm._m(0),_c('p',[_vm._v("您没有权限查看此页面")]),_c('p',[_vm._v(" 请刷新页面或者 "),_c('a-button',{attrs:{"type":"primary"}},[_c('router-link',{attrs:{"to":"/"},on:{"click":_vm.logout}},[_vm._v("返回首页")])],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorCode"},[_vm._v(" 错误 "),_c('span',[_vm._v("404")])])
}]

export { render, staticRenderFns }